var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.58576C0 7.03347 0.447716 6.58576 1 6.58576H13.5898L8.71117 1.70711C8.32064 1.31658 8.32064 0.683418 8.71117 0.292893C9.10169 -0.0976309 9.73486 -0.0976313 10.1254 0.292893L16.7071 6.87462C16.9029 7.0704 17.0005 7.32715 17 7.58374C17.0005 7.84034 16.9029 8.09709 16.7071 8.29286L10.1254 14.8746C9.73486 15.2651 9.10169 15.2651 8.71117 14.8746C8.32064 14.4841 8.32064 13.8509 8.71117 13.4604L13.5858 8.58576H1C0.447716 8.58576 0 8.13804 0 7.58576Z",
    fill: "#1F202F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlack);
export default __webpack_public_path__ + "static/media/rightBlack.5f154de1d11f31bc49e0359572a8cfcc.svg";
export { ForwardRef as ReactComponent };